import { useMutation } from '@tanstack/react-query';
import { submitTagSale } from '../services/tagSubmission.service';
import type { TagSubmissionData } from '../types/tagSubmission.types';

export const useTagSubmission = () => {
  return useMutation({
    mutationFn: (data: TagSubmissionData) => submitTagSale(data),
    onError: (error) => {
      // You can handle errors here or let components handle them
      console.error('Tag submission failed:', error);
    },
  });
};
